import React from 'react';
import { Box, Button, TextField, Typography, InputAdornment } from '@mui/material';

const CurrencyInput = ({
  value,
  onChange,
  placeholder = "0.0000",
  showPercentage = false,
  showPlusButton = false,
  width = 120,
  size = "small",
  name,
  disabled = false
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        size={size}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        sx={{ width }}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>
        }}
        inputProps={{
          name: name
        }}
      />
      {showPercentage && (
        <Typography variant="body2" sx={{ color: 'grey.600' }}>%</Typography>
      )}
      {showPlusButton && (
        <Button size="small" variant="outlined" sx={{ minWidth: 32, height: 32 }}>
          +
        </Button>
      )}
    </Box>
  );
};

export default CurrencyInput;
